import { useEffect, useImperativeHandle, useState } from 'react';
import Switch from '../../../../components/layout/switch';
import { PilotAssignmentCommands } from '../../services/DispatcherActions';
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const ReimbursementCard = (
    {
        ref,
        onPilotAssignmentChanged,
        assignmentService
    }) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initialize();
        }
    }));

    const [isEditable, setIsEditable] = useState(false);
    const [isReimbursementExcluded, setIsReimbursementExcluded] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const isEditableChanged = useHasEditableChanged();
    
    useEffect(() => {
        initialize()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!isEditableChanged) return;
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditableChanged]);
    
    return (
        <Switch
            disabled={!isEditable}
            onLabel="Ingen reiseregning"
            onChange={onChangeAsync}
            checked={isReimbursementExcluded}
            isDirty={isDirty}
        />
    )

    function initialize() {
        const pilotAssignment = assignmentService.assignment;
        setIsReimbursementExcluded(!pilotAssignment.pilotagePilotCompensation.isReimbursementIncluded)
        setIsEditable(assignmentService.isEditable);

        initializeIsDirty();
    }
        
    async function onChangeAsync(e) {
        setIsReimbursementExcluded(e.value);

        await assignmentService.onUpdateReimbursmentStatusAsync(e.value);

        onPilotAssignmentChanged();

        initializeIsDirty();
    }

    function initializeIsDirty() {
        setIsDirty(assignmentService.hasCommandType(PilotAssignmentCommands.UpdateReimbursmentStatus));
    }
}
